// src/services/azureAuthService.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5513/api";

/**
 * Valida un token de Azure AD con el backend
 * y obtiene los tokens JWT de la aplicación
 */
export const validateAzureToken = async (accessToken, account) => {
  try {
    const response = await axios.post(`${API_URL}/auth/azure/validate`, {
      accessToken,
      account,
    });

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Error al validar token de Azure AD";
    throw new Error(errorMessage);
  }
};

/**
 * Obtiene la URL de autorización de Azure AD
 */
export const getAzureAuthUrl = async () => {
  try {
    const response = await axios.get(`${API_URL}/auth/azure/login`);
    return response.data.authUrl;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Error al obtener URL de autenticación";
    throw new Error(errorMessage);
  }
};
